import React, { useEffect, useState } from "react";
import Select from "react-select";

export type Option = {
  value: string;
  label: string;
};

export interface SelectProps {
  options: Option[];
  defaultValue?: Option;
  className?: string;
  styles?: any;
  onChange?: (option: Option | null) => void; // Added onChange to props
}

const CommonSelect: React.FC<SelectProps> = ({ options, defaultValue, className, onChange }) => {
  const [selectedOption, setSelectedOption] = useState<Option | undefined>(defaultValue);

  const handleChange = (option: Option | null) => {
    setSelectedOption(option || undefined);
    if (onChange) {
      onChange(option); // Call the parent component's handler
    }
  };

  useEffect(() => {
    setSelectedOption(defaultValue || undefined);
  }, [defaultValue]);

  return (
    <Select
      classNamePrefix="react-select"
      className={className}
      options={options}
      value={selectedOption}
      onChange={handleChange}
      placeholder="Select"
    />
  );
};

export default CommonSelect;





































// import React, { useEffect, useState } from "react";
// import Select from "react-select";

// export type Option = {
//   value: string;
//   label: string;
// };

// export interface SelectProps {
//   options: Option[];
//   defaultValue?: Option;
//   className?: string;
//   styles?: any; 
//   onChange?: (option: Option | null) => void;
// }

// const CommonSelect: React.FC<SelectProps> = ({ options, defaultValue, className }) => {
//   const [selectedOption, setSelectedOption] = useState<Option | undefined>(defaultValue);

 

//   const onChange = (option: Option | null) => {
//     setSelectedOption(option || undefined);
//   };
//   useEffect(() => {
//     setSelectedOption(defaultValue || undefined);
//   }, [defaultValue])
  
//   return (
//     <Select
//      classNamePrefix="react-select"
//       className={className}
//       // styles={customStyles}
//       options={options}
//       value={selectedOption}
//       // onChange={handleChange}
//       onChange={onChange}  // Use the parent’s handler
//       placeholder="Select"
//     />
//   );
// };

// export default CommonSelect;
